import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Page from '../../Page';
import EmailConfigurator, { EmailConfiguratorProvider } from './EmailConfigurator';

import * as styles from './ReceiptSettingsPage.css';

function ReceiptSettingsPage(): JSX.Element {
  const { t } = useTranslation();

  return (
    <EmailConfiguratorProvider>
      <Page
        collapseHeader={true}
        contentClassName={styles.root}
        legacyScrollClassName={styles.legacyScroll}
        title={t('Receipt Settings')}
      >
        <EmailConfigurator.Content />
        <EmailConfigurator.ActionBar />
      </Page>
    </EmailConfiguratorProvider>
  );
}

export default ReceiptSettingsPage;
